import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001'

// Configurar axios
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000, // 60 segundos para operações pesadas (Clicksign, PDF, etc)
})

// Interceptor para adicionar token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Interceptor para tratar respostas com refresh automático
let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) prom.reject(error)
    else prom.resolve(token)
  })
  failedQueue = []
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    if (error.response?.status === 401 && !originalRequest._retry) {
      const refreshToken = localStorage.getItem('refreshToken')
      if (!refreshToken) {
        localStorage.removeItem('token')
        window.location.href = '/login'
        return Promise.reject(error)
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject })
        }).then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`
          return api(originalRequest)
        })
      }

      originalRequest._retry = true
      isRefreshing = true

      try {
        const res = await axios.post(`${API_BASE_URL}/api/auth/refresh`, { refreshToken })
        const { token, refreshToken: newRefreshToken } = res.data
        localStorage.setItem('token', token)
        if (newRefreshToken) localStorage.setItem('refreshToken', newRefreshToken)
        api.defaults.headers.common.Authorization = `Bearer ${token}`
        processQueue(null, token)
        originalRequest.headers.Authorization = `Bearer ${token}`
        return api(originalRequest)
      } catch (refreshError) {
        processQueue(refreshError, null)
        localStorage.removeItem('token')
        localStorage.removeItem('refreshToken')
        window.location.href = '/login'
        return Promise.reject(refreshError)
      } finally {
        isRefreshing = false
      }
    }
    return Promise.reject(error)
  }
)

export const authService = {
  // Login
  async login(email, password) {
    const response = await api.post('/api/auth/login', {
      email,
      password
    })
    return response.data
  },

  // Logout
  async logout() {
    const response = await api.post('/api/auth/logout')
    return response.data
  },

  // Verificar token
  async verifyToken() {
    const response = await api.get('/api/auth/verify')
    return response.data
  },

  // Buscar perfil
  async getProfile() {
    const response = await api.get('/api/auth/profile')
    return response.data
  }
}

export { api }
export default authService